/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated, do not edit it manually",
 */

import React from "react";

import {
  type AnimatedIllustrativeBaseIconProps,
  AnimatedIllustrativeIcon,
} from "../animated-illustrative-icon";
import animationData from "../assets/json/user-logout-offblack-animated.json";

export const IllustrativeIconUserLogoutOffblackAnimated = (props: AnimatedIllustrativeBaseIconProps) => (
  <AnimatedIllustrativeIcon {...props} json={animationData} />
);

IllustrativeIconUserLogoutOffblackAnimated.displayName = "IllustrativeIconUserLogoutOffblackAnimated";
